export const userSelector = (id) => (state) => state.users[id];
